import * as actionTypes from '../actions/actionTypes'

const initialState = {
  notices: {
    notices: [],
    isLoading: false,
    isError: false
  },
  workerNotices: {
    workerNotices: undefined,
    isLoading: false,
    isError: false
  },
  workerNoticeAction: {
    code: undefined,
    noticeID: undefined,
    action: undefined,
    isLoading: false,
    isError: false
  },
  isLoading: false,
  isError: false
}

// const updateWorkerNotice = (currentState, noticeID, action) => {
//   const tempNotices = currentState.workerNotices.workerNotices.notices.filter(n => n.noticeID !== noticeID)
//   const tempUpdatedNotice = currentState.workerNotices.workerNotices.notices.filter(n => n.noticeID === noticeID)[0]
//   return [...tempNotices, { ...tempUpdatedNotice, status: action === 'RELEASE' ? 'Not Printed' : 'On Hold', action: action === 'RELEASE' ? 'HOLD' : 'RELEASE' }]
// }

const noticeReducer = (state = initialState, action = {}) => {
  const newState = { ...state }

  switch (action.type) {
    case actionTypes.FETCH_NOTICES:
      return { ...newState, notices: { ...newState.notices, isLoading: true } }

    case actionTypes.FETCH_NOTICES_SUCCESS:
      return { ...newState, notices: { notices: [...action.payload], isLoading: false, isError: false } }

    case actionTypes.FETCH_NOTICES_FAILURE:
      return { ...newState, isLoading: false, isError: true }

    case actionTypes.FETCH_WORKER_NOTICES:
      return { ...newState, workerNotices: { ...newState.workerNotices, isLoading: true } }

    case actionTypes.FETCH_WORKER_NOTICES_SUCCESS:
      return { ...newState, workerNotices: { workerNotices: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.FETCH_WORKER_NOTICES_FAILURE:
      return { ...newState, workerNotices: { ...newState.workerNotices, isLoading: false, isError: true } }

    case actionTypes.WORKER_NOTICE_ACTION:
      return { ...newState, workerNoticeAction: { ...newState.workerNoticeAction, code: '', isLoading: true, isError: false } }

    case actionTypes.WORKER_NOTICE_ACTION_SUCCESS:
      return { ...newState, workerNotices: { workerNotices: { ...newState.workerNotices.workerNotices }, isLoading: false, isError: false }, workerNoticeAction: { code: action?.payload?.response?.status, noticeID: action.payload.data.noticeID, action: action.payload.data.action, isLoading: false, isError: false } }

    case actionTypes.WORKER_NOTICE_ACTION_FAILURE:
      return { ...newState, workerNoticeAction: { code: action?.payload?.error?.response?.data?.code, noticeID: action.payload.data.noticeID, action: action.payload.data.action, isLoading: false, isError: true } }

    default:
      return { ...newState }
  }
}

export default noticeReducer
